export interface GroupForecast {
  id: string;
  timestamps: string[];
  mean: number[];
  quantiles?: Record<string, number[]>;
}

export interface ForecastBody {
  horizon: number;
  freq: string;
  groups: GroupForecast[];
}

export interface ResultForecastProps {
  forecast: ForecastBody;
}

function fmtNum(v: number | undefined | null): string {
  if (v == null || !Number.isFinite(v)) return "—";
  return v.toString();
}

export function ResultForecast({ forecast }: ResultForecastProps) {
  if (!forecast.groups || forecast.groups.length === 0) {
    return <div className="text-xs text-fg-muted">No forecast groups returned.</div>;
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3 text-[11px] text-fg-muted">
        <span>
          Horizon: <span className="font-mono text-fg">{forecast.horizon}</span>
        </span>
        <span>
          Freq: <span className="font-mono text-fg">{forecast.freq}</span>
        </span>
        <span>
          Groups: <span className="font-mono text-fg">{forecast.groups.length}</span>
        </span>
      </div>

      {forecast.groups.map((g) => {
        const qLevels = Object.keys(g.quantiles ?? {});
        return (
          <div key={g.id} className="rounded-md border border-border">
            <div className="border-b border-border bg-surface-2 px-3 py-1.5 text-[11px] font-mono">
              {g.id}
            </div>
            <table className="w-full text-xs">
              <thead>
                <tr className="text-left text-fg-muted border-b border-border">
                  <th className="px-3 py-1.5">Timestamp</th>
                  <th className="px-3 py-1.5">Mean</th>
                  {qLevels.map((q) => (
                    <th key={q} className="px-3 py-1.5">
                      {q}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {g.timestamps.map((ts, i) => (
                  <tr key={ts} className="border-b border-border/60">
                    <td className="px-3 py-1.5 font-mono text-fg-dim">{ts}</td>
                    <td className="px-3 py-1.5 font-mono tnum">{fmtNum(g.mean[i])}</td>
                    {qLevels.map((q) => (
                      <td key={q} className="px-3 py-1.5 font-mono tnum">
                        {fmtNum(g.quantiles?.[q]?.[i])}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}
